import React from "react";
import { reportarErro } from "../utils/logs";

// Tela que quebra na renderização vira log (log_erro, origem 'web') + mensagem
// amigável, em vez de página branca.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    reportarErro({
      mensagem: erro?.message || String(erro),
      stack: erro?.stack,
      contexto: { tipo: "ErrorBoundary", componentStack: info?.componentStack?.slice(0, 4000) },
    });
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
        <div className="text-center" style={{ maxWidth: 460 }}>
          <h5 className="mb-2">Algo deu errado nesta tela</h5>
          <p className="text-muted mb-4">
            O erro foi registrado para a equipe de sistemas. Tente recarregar a página.
          </p>
          <button type="button" className="btn btn-primary me-2" onClick={() => window.location.reload()}>
            Recarregar
          </button>
          <button type="button" className="btn btn-outline-secondary" onClick={() => window.location.assign("/")}>
            Ir para o início
          </button>
        </div>
      </div>
    );
  }
}
